import { HIDE_CONTAINER_HEADER_CLASSNAME } from '@components/hide-container/hide-container';
import { SidebarReadOnlyContext, showSidebar } from '@components/sidebar';

import { TEMPLATE_PREVIEW_BUTTON_CLASSNAME } from 'ui/actions/common';
import { sidebarContentMap } from 'ui/journey-builder/action-sidebar';
import { JourneyNodeBase } from 'ui/journey-builder/node-types/types';

export const showTemplateActionSidebar = (node: JourneyNodeBase) => {
  const hasSidebar = node.type in sidebarContentMap;
  if (hasSidebar) {
    const SidebarComponent = sidebarContentMap[node.type as keyof typeof sidebarContentMap];
    showSidebar({
      component: (props) => (
        <SidebarReadOnlyContext.Provider value={true}>
          <SidebarComponent {...props} />
        </SidebarReadOnlyContext.Provider>
      ),
      options: {
        variant: 'REGULAR',
        id: node.id,
        containerStyle: {
          '#sidebar-footer': {
            display: 'none',
          },
          [`.${HIDE_CONTAINER_HEADER_CLASSNAME}, .${TEMPLATE_PREVIEW_BUTTON_CLASSNAME}`]: {
            zIndex: 1,
          },
        },
      },
      props: { journeyActionId: node.id },
    });
  }
};
